module.exports = __webpack_public_path__ + "static/media/logo.82c7e584.svg";